<template>

    <main class="skiplink-target main" id="content" tabindex="-1">
        <div class="container">
            <header class="row">
                <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                    <div class="content content--header">
                        <section class="content-header">
                            <h1>{{labels.gegevensInvoerScherm.kop}}</h1>
                            <p>{{labels.gegevensInvoerScherm.stapIndicator}}</p>
                        </section>
                    </div>
                </div>
            </header>
            <article>
                <div class="row">
                    <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
                        <div class="content-background">
                            <div class="content">
                                <h2>{{labels.gegevensInvoerScherm.subkopPersonalia}}</h2>
                                <div v-bind:class="[inputClass, {'input--invalid': v$.voorletters.$error}]">
                                    <div class="input__error" v-if="!v$.voorletters.required">{{labels.errors.verplichtVeldVoorletters}}</div>
                                    <label class="input__label" for="voorletters">{{labels.gegevensInvoerScherm.voorletters}}</label>
                                    <input type="text" id="voorletters"
                                           v-on:keypress="isLetter($event)"
                                           class="input__control input__control--xs input__control--text"
                                           v-model="voorletters" :maxlength="10" @blur="() => { this.v$.voorletters.$touch() }">
                                </div>

                                <div v-bind:class="[inputClass, {'input--invalid': v$.achternaam.$error}]">
                                    <div class="input__error" v-if="!v$.achternaam.required">{{labels.errors.verplichtVeldAchternaam}}</div>
                                    <label class="input__label" for="achternaam">{{labels.gegevensInvoerScherm.achternaam}}</label>
                                    <input type="text" id="achternaam"
                                           v-on:keypress="isLetter($event)"
                                           class="input__control input__control--l input__control--text"
                                           v-model="achternaam" :maxlength="60"  @blur="() => { this.v$.achternaam.$touch() }">
                                </div>

                                <div v-if="this.veldopties.bsn"
                                     v-bind:class="[inputClass, {'input--invalid': v$.comBsn.$error}]">
                                    <div class="input__error" v-if="!v$.comBsn.required">{{labels.errors.verplichtVeldBSN}}</div>
                                    <div class="input__error" v-if="!v$.comBsn.isValidBSN">{{labels.errors.geldigBsn}}
                                    </div>
                                    <label class="input__label"
                                           for="bsn">{{labels.gegevensInvoerScherm.bsn}} <span v-if="isStandaardBSNText" class="label label--optional">optioneel</span></label>
                                    <span class="input__hint"
                                          for="bsn" v-if="isStandaardBSNText">{{labels.gegevensInvoerScherm.uitlegbsn}}</span>
                                    <span class="input__hint"
                                          for="bsn" v-if="!isStandaardBSNText">{{labels.gegevensInvoerScherm.uitlegbsnextra}}</span>
                                    <input v-model.lazy="comBsn" type="number" id="bsn"
                                           class="input__control input__control--m input__control--text" :maxlength="9" @blur="() => { this.v$.comBsn.$touch() }">
                                </div>
                            </div>

                            <div class="content" v-if="this.veldopties.adres">
                                <h2>{{labels.gegevensInvoerScherm.subkopAdres}}</h2>
                                <label v-if="redenContact === 'inschrijven-uitschrijven'"
                                       class="input__label input__hint" for="straat">{{labels.gegevensInvoerScherm.toelichtingAdresNodig}}</label>
                                <fieldset v-bind:class="[inputClass]">
                                    <legend>
                                        {{labels.gegevensInvoerScherm.landkeuze}} <span class="label label--optional">optioneel</span>
                                    </legend>
                                    <div v-for="land of landKeuze" v-bind:key="land.value"
                                         class="input__group input__group--radio">
                                        <input type="radio" name="optradio" :id="land.value"
                                               class="input__control input__control--radio" :value="land.value"
                                               v-model="landmodel">
                                        <label class="input__label input__label--radio"
                                               :for="land.value">{{land.label}}</label>
                                    </div>
                                </fieldset>


                                <div v-if="nlAdres"
                                    v-bind:class="[inputClass, {'input--invalid': v$.adres.$error}]">
                                    <div class="input__error" v-if="!v$.adres.isValidText">{{labels.errors.geldigTekstNlAdres}}</div>
                                    <label class="input__label" for="straat">{{labels.gegevensInvoerScherm.adres}} <span class="label label--optional">optioneel</span></label>
                                    <input type="text" id="straat"
                                           class="input__control input__control--xl input__control--text"
                                           v-model="adres" :maxlength="60">
                                </div>
                                <div v-if="nlAdres"
                                     v-bind:class="[inputClass, {'input--invalid': v$.postcode.$error}]">
                                    <div class="input__error" v-if="!v$.postcode.isValidPcode">{{labels.errors.geldigPostcode}}
                                    </div>
                                    <label class="input__label" for="postcode">{{labels.gegevensInvoerScherm.postcode}} <span class="label label--optional">optioneel</span></label>
                                    <input type="text" id="postcode" name="pcode"
                                           class="input__control input__control--s input__control--text"
                                           v-model.lazy="postcode" :maxlength="60">
                                </div>
                                <div v-if="nlAdres"
                                     v-bind:class="[inputClass, {'input--invalid': v$.plaats.$error}]">
                                    <label class="input__label" for="plaats">{{labels.gegevensInvoerScherm.plaats}} <span class="label label--optional">optioneel</span></label>
                                    <input type="text" id="plaats"
                                           v-on:keypress="isLetter($event)"
                                           class="input__control input__control--l input__control--text"
                                           v-model="plaats" :maxlength="60">
                                </div>

                                <div v-if="!nlAdres"
                                     v-bind:class="[inputClass, {'input--invalid': v$.adresbuitenland.$error}]">
                                    <div class="input__error" v-if="!v$.adresbuitenland.isValidText">{{labels.errors.geldigTekstBlAdres}}</div>
                                    <label class="input__label" for="adresbuitenland">{{labels.gegevensInvoerScherm.buitenland}} <span class="label label--optional">optioneel</span></label>
                                    <textarea id="adresbuitenland"
                                              class="input__control input__control--l input__control--text"
                                              v-model="adresbuitenland"></textarea>
                                </div>


                            </div>
                            <div class="content">
                                <h2>{{labels.gegevensInvoerScherm.subkopContactgegevens}}</h2>

                                <div v-bind:class="[inputClass, {'input--invalid': v$.email.$error}]">
                                    <div class="input__error" v-if="!v$.email.required">{{labels.errors.verplichtVeldEmailadres}}</div>
                                    <div class="input__error" v-if="!v$.email.email">{{labels.errors.geldigEmail}}
                                    </div>
                                    <label class="input__label" for="email">{{labels.gegevensInvoerScherm.emailadres}}</label>
                                    <input type="email" id="email"
                                           class="input__control input__control--l input__control--text"
                                           v-model.lazy="email" :minlength="4" :maxlength="256" @blur="() => { this.v$.email.$touch() }">
                                </div>

                                <div v-bind:class="[inputClass, {'input--invalid': v$.telefoon.$error}]">
                                    <div class="input__error" v-if="!v$.telefoon.maxLength">{{labels.errors.geldigTelefoonnummer}}
                                    </div>
                                    <label class="input__label" for="telefoonnummer">{{labels.gegevensInvoerScherm.telefoonnummer}} <span class="label label--optional">optioneel</span></label>
                                    <input type="number" id="telefoonnummer"
                                           class="input__control input__control--m input__control--text"
                                           v-model.lazy="telefoon" ::maxlength="22">
                                </div>

                                <p>

                                    <button v-bind:class="[btnClass, {'btn--disabled ': v$.$invalid}]"
                                            @click="gaVerder">{{labels.algemeen.button}}
                                    </button>
                                    {{labels.algemeen.of}}
                                    <router-link :to="{name: 'vraag'}">{{labels.algemeen.labelVorige}}
                                    </router-link>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </main>
</template>

<script>
    import {mapGetters} from 'vuex';
    import { useVuelidate } from '@vuelidate/core'
    import {required, email, requiredIf, maxLength} from '@vuelidate/validators'

    const isValidText = function (value){
        if (value != undefined && value != "") {
                var regex = /^[A-Za-z0-9,-./áÁàÀâÂäÄãÃåÅæÆçÇdÐðÐéÉèÈêÊëËƒíÍìÌIîÎïÏñÑóÓòÒôÔöÖõÕøØšŠßþÞúÚùÙûÛüÜýÝÿŸŽž\s]+$/i;
                return (regex.test(value));
        }
        return true;
    };
    const isOnlyText = function (value) {
                var re = /[^A-Za-z,-./áÁàÀâÂäÄãÃåÅæÆçÇdÐðÐéÉèÈêÊëËƒíÍìÌIîÎïÏñÑóÓòÒôÔöÖõÕøØšŠßþÞúÚùÙûÛüÜýÝÿŸŽž\s]/gi;
                var er = value.value;
                value.value = er.replace(re, "");
                return value;        
            };

    const isValidBSN = function (value) {
        if (value != undefined) {
            const bsn = parseInt(value);

            if (isNaN(bsn)){
                this.$store.state.form.gegevens.bsn = undefined;
                return true
            }

            if (bsn === undefined || bsn.length === 0) {
                return false
            }

            const length = bsn.toString().length;
            if (length < 8 || length > 9 || !/^[0-9]{8,9}$/.test(bsn)) {
                return false
            }

            let pos = 0;
            let result = 0;

            for (let i = length; i > 0; i--) {
                result += (i !== 1) ? (value.toString().charAt(pos) * i) : (value.toString().charAt(pos) * i * -1);
                pos++;
            }
            return (result % 11 === 0)
        }
        return true;
    };

    const isValidPcode = function (value){
        // hier een controle op landcode 'nl' of 'anders'
        if (value != undefined) {
            if (this.adresGegevens.land === 'nl') {
                var regex = /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/;
                return (regex.test(value));
            }
        }
        return true;
    };

    export default {
        name: "gegevensInvoeren",
        setup () {
            return {
                v$: useVuelidate()
            }
        },
        data() {
            return {
                inputClass: 'input',
                btnClass: 'btn btn--primary',
                landKeuze: [
                    {
                        value: 'nl',
                        label: 'Nederland'
                    },
                    {
                        value: 'anders',
                        label: 'Een ander land'
                    }
                ]
            }
        },
        methods: {
            isLetter(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if(/^[A-Za-z,-./áÁàÀâÂäÄãÃåÅæÆçÇdÐðÐéÉèÈêÊëËƒíÍìÌIîÎïÏñÑóÓòÒôÔöÖõÕøØšŠßþÞúÚùÙûÛüÜýÝÿŸŽž\s]+$/.test(char)) return true; // Match with regex 
                else e.preventDefault(); // If not match, don't add to input text
            },
            setInput(event, type) {
                let x = {type, value: event.target.value}
                this.$store.commit('setPersoonsGegevens', x)
            },
            gaVerder() {
                this.v$.$touch();

                if (!this.v$.$invalid) {
                    this.$router.push({name: 'controleren'});
                } else {
                   return
                }
            }
        },
        computed: {
            ...mapGetters(['veldopties', 'redenContact', 'labels', 'bsn', 'adresGegevens']),
            comBsn: {
                set(bsn) {
                        this.v$.comBsn.$touch();
                        this.$store.commit('setBsn', bsn)
                },
                get() {
                    return this.$store.state.form.gegevens.bsn
                }
            },
            landmodel: {
                set(x) {
                    let y = {type: 'land', value: x}
                    this.$store.commit('setAdresGegevens', y)
                },
                get() {
                    return this.$store.state.form.gegevens.adresGegevens.land
                }
            },

            voorletters: {
                set(voorletters) {
                    this.v$.voorletters.$touch();
                    let x = {type: 'voorletters', value: voorletters}
                    x = isOnlyText(x);
                    this.$store.commit('setPersoonsGegevens', x)
                },
                get() {
                    return this.$store.state.form.gegevens.persoonsGegevens.voorletters;
                }
            },
            achternaam: {
                set(naam) {
                    this.v$.achternaam.$touch();
                    let x = {type: 'achternaam', value: naam};
                    x = isOnlyText(x);
                    this.$store.commit('setPersoonsGegevens', x);
                },
                get() {
                    return this.$store.state.form.gegevens.persoonsGegevens.achternaam;
                }
            },
            adres: {
                set(adres) {
                    this.v$.adres.$touch();
                    let x = {type: 'straat', value: adres};
                    this.$store.commit('setAdresGegevens', x)
                },
                get() {
                    return this.$store.state.form.gegevens.adresGegevens.straat;
                }
            },
            adresbuitenland: {
                set(adres) {
                    let x = {type: 'adresbuitenland', value: adres};
                    this.v$.adresbuitenland.$touch();
                    this.$store.commit('setAdresGegevens', x)
                },
                get() {
                    return this.$store.state.form.gegevens.adresGegevens.adresbuitenland;
                }
            },
            postcode: {
                set(postcode) {
                    let x = {type: 'postcode', value: postcode};
                    this.v$.postcode.$touch();
                    this.$store.commit('setAdresGegevens', x)
                },
                get() {
                    return this.$store.state.form.gegevens.adresGegevens.postcode
                }
            },
            plaats: {
                set(plaats) {
                    this.v$.plaats.$touch();
                    let x = {type: 'plaats', value: plaats};
                    x = isOnlyText(x);
                    this.$store.commit('setAdresGegevens', x)
                },
                get() {
                    return this.$store.state.form.gegevens.adresGegevens.plaats
                }
            },
            email: {
                set(email) {
                    this.v$.email.$touch();
                    let x = {type: 'emailAdres', value: email};
                    this.$store.commit('setContactGegevens', x)
                },
                get() {
                    return this.$store.state.form.gegevens.contactGegevens.emailAdres;
                }
            },
            telefoon: {
                set(x) {
                    this.v$.telefoon.$touch();
                    let y = {type: 'telefoonnummer', value: x}
                    this.$store.commit('setContactGegevens', y)
                },
                get() {
                    return this.$store.state.form.gegevens.contactGegevens.telefoonnummer;
                }
            },
            nlAdres() {
                return (this.landmodel === 'nl')
            },
            isStandaardBSNText(){
                if (this.$store.state.form.redenContact === "bericht-personenregister"){
                    return false;
                }
                return true;
            }
        },
        created() {
            this.$trackPageView('gegevens-invoeren');              
        },
        validations() {
            if (this.veldopties.bsn && !this.veldopties.adres) {
                return {
                    voorletters: {
                        required
                    },
                    achternaam: {
                        required
                    },
                    comBsn: {
                        required: requiredIf(() => !this.isStandaardBSNText),
                        isValidBSN
                    },
                    email: {
                        required,
                        email},
                    telefoon: {
                        maxLength: maxLength(22)
                    }
                }
            }
            else if(this.veldopties.adres && !this.veldopties.bsn){
                return {
                    voorletters: {
                        required
                    },
                    achternaam: {
                        required
                    },
                    adres: {
                        isValidText
                    },
                    plaats: {
                    },
                    postcode: {
                        isValidPcode
                    },
                    adresbuitenland: {
                        isValidText
                    },
                    email: {
                        required,
                        email},
                    telefoon: {
                        maxLength: maxLength(22)
                    }
                }
            }
            else if(!this.veldopties.adres && !this.veldopties.bsn){
                return {
                    voorletters: {
                        required
                    },
                    achternaam: {
                        required
                    },
                    email: {
                        required,
                        email},
                    telefoon: {
                        maxLength: maxLength(22)
                    }
                }
            }
            else {
                return {
                    voorletters: {
                        required
                    },
                    achternaam: {
                        required
                    },
                    comBsn: {
                        required: requiredIf(() => !this.isStandaardBSNText),
                        isValidBSN
                    },
                    adres: {
                        isValidText
                    },
                    plaats: {
                    },
                    postcode: {
                        isValidPcode
                    },
                    adresbuitenland: {
                        isValidText
                    },
                    email: {
                        required,
                        email},
                    telefoon: {
                        maxLength: maxLength(22)
                    }
                }

            }

        }

    }
</script>

<style scoped>

</style>
